<!--
  ~ Copyright (c) 2019
  ~    Reliant Business Valuation, LLC - http://reliantvalue.com
  ~    Author: Kirill Vizniuk - kirill@internalvaluation.com
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div  class="input-search-container" #rootElement>
  <div class="input-container multiple" [ngClass]="{'disabled': disabled, 'bordered': invalid,
    'has-warning': required && (inputText.errors && (inputText.dirty || inputText.touched))}">

    <ng-container>
      <div *ngFor="let arr of arrValue; let i=index" class="mvalue" [ngClass]="{'disabled': disabled}">
        <div class="name">{{getValue(arr)}}</div>
        <div class="remove"><i class="fa fa-times" aria-hidden="true" (click)="removeSelected(i)"></i></div>
      </div>
    </ng-container>

    <input #inputText type="text" class="input-search crm-field regular" autocomplete="off"
      [ngClass]="{'right-bordered': invalid}" [name]="name"
      [(ngModel)]="searchQuery" [disabled]="disabled"
      [placeholder]="''" [required]="required" (focus)="onShow()" />

     <!-- <ng-container>
       <a (click)="onShow()" [ngClass]="{'disabled': disabled}" class="dropdown-button">
         <i class="fa fa-angle-down" aria-hidden="true"></i>
       </a>
     </ng-container> -->

    <span class="help-block" *ngIf='required && (inputText.errors && (inputText.dirty || inputText.touched))'>
      required
    </span>
  </div>

  <div *ngIf="isOpen" class="dropdown-items" [ngClass]="{'bottom': !topFlag ,'top': topFlag}">
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-icon-small"></div>
    </div>

    <div #container (scroll)="onScrollHandler($event)" *ngIf="!isLoading" id="DROPDOWN_ITEMS" class="item-container">
      <ng-container *ngIf="preset?.length > 0 && searchQuery.length <= 0">
        <div class="header" *ngIf="presetHeader">{{presetHeader}}</div>
        <div class="item preset" [id]="'PRESET_ITEMS_' + pi"
          [ngClass]="{'active': p.active, 'offset': presetHeader }"
          (click)="onSelected(p)" *ngFor="let p of preset; let pi=index">
          {{displayFull ? p.getFullDetails() : p.getName()}}
        </div>
      </ng-container>

    </div>
  </div>
</div>
